import { validateIHI } from "./ValidateIhiNumber";

// CU-14ygtkj65rw (HI_035_005845): a printed IHI is all 16 digits as a 4*4*4*4 split string; anything else prints nothing.
export const formatIhiForPrint = (ihi: unknown): string | null => {
	const digits = typeof ihi === "string" ? ihi : typeof ihi === "number" && Number.isSafeInteger(ihi) ? String(ihi) : null;
	if (digits === null || !validateIHI(digits).isValid) return null;
	return `${digits.slice(0, 4)} ${digits.slice(4, 8)} ${digits.slice(8, 12)} ${digits.slice(12, 16)}`;
};
